<div class="content-wrapper">
  <div class="container">
    <em-personal-advisor [showDefaultTitle]="false">
      @if (isLoading | async) {
        <em-spinner [overContent]="true"></em-spinner>
      }
      <div class="step-content">
        <router-outlet></router-outlet>
      </div>
    </em-personal-advisor>
  </div>
</div>
